module.exports = __webpack_public_path__ + "static/media/investor.a6ae4aae.webp";